export default {
  banners: {
    welcome: {
      title: 'Welcome to Injective!',
      subtitle: 'Just a few more steps and you’re good to go!',
      depositDescription:
        'Use Injective Bridge to transfer assets in your wallet.',
      transferDescription:
        'Transfer to your Injective Trading Account to start trading.',
      tradeDescription:
        'You are ready to Trade. Choose a market to get started!',
      showAddress: 'Show address',
      howItWorks: 'How it works',
      faq: 'F.A.Q'
    },
    kado: {
      title: 'Onboard onto Injective instantly with fiat!',
      tryNow: 'Get started'
    },
    'banner-sheduled-upgrade-march':
      "A scheduled maintenance will take place around 16:00 UTC, 17 March 2023. Please note that you won't be able to place orders and manage positions during the downtime.",
    userFeedback: {
      loveFeedback: "We'd love to hear your feedback!",
      thankYouBeginning:
        'Thank you for using Parallel. We are constantly improving our products for our users and we’d love to hear from you! The survey should take fewer than ',
      threeMinutes: '3 minutes ',
      thankYouEnd:
        'to complete and the information will help us know how to improve your future experience on Parallel.',
      takeSurvey: 'Take the survey',
      notRightNow: 'Not right now'
    }
  }
}
